import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Navbar from './components/Navbar'
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import LoanRepayment from './pages/LoanRepayment'
import Contact from './pages/Contact'
import AdminDashboard from './admin/AdminDashboard'
import AdminEnquiry from './admin/AdminEnquiry'
import AdminLogin from './admin/AdminLogin'



const App = () => {

  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

  return (
    <>
    {!isLoggedIn && (
      <div>
        {/* <Navbar /> */}
        <div className='min-h-[70vh]'>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/about' element={<About />} />
            <Route path='/services' element={<Services />} />
            <Route path='/loan-repayment' element={<LoanRepayment />} />
            <Route path='/contact' element={<Contact />} />

            <Route path='/admin-login' element={<AdminLogin />} />
          </Routes>
        </div>
      </div>
    )}


    {isLoggedIn && (
        <>
          <Routes>
            <Route exact path='/' element={<AdminDashboard />} />
            <Route exact path='/dashboard' element={<AdminDashboard/>} />
            <Route exact path='/enquiry' element={<AdminEnquiry />} />
          </Routes>
        </>
      )}
    </>
  )
}

export default App